import React from 'react';
export var ContainerTargetContext = /*#__PURE__*/React.createContext(typeof document === 'object' ? document.body : undefined);